import { STATUS_CODE } from "@/core/config/constant";
import {SET_ERROR} from "@/core/services/store/auth.module";
import { history } from "@/core/services/apis/history";


const { ERROR_SERVER, SUCCESS } = STATUS_CODE;

export const GET_HISTORY_LIST = "getHistoryList";
export const HISTORY_LIST = "historyList";

const state = {
    historyList: {},
};

const getters = {
    historyList: state => state.historyList
};

const mutations = {
    [HISTORY_LIST](state, data) {
        state.historyList = data;
    },
};

const actions = {
    async [GET_HISTORY_LIST](context, query){
        try {
            let response = await history.list(query);
            if (response.data.code == SUCCESS) {
                context.commit(HISTORY_LIST, response.data.data);
            } else {
                throw response.data.message;
            }
        } catch (e) {
            if (e.response.data.code == ERROR_SERVER) {
                context.commit(SET_ERROR, e.response.data.message);
                throw e.response.data.message
            } else {
                throw e;
            }
        }
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
